var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_4279)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 3V0H4.75C4.55109 0 4.36032 0.0790176 4.21967 0.21967C4.07902 0.360322 4 0.551088 4 0.75V12.25C4 12.4489 4.07902 12.6397 4.21967 12.7803C4.36032 12.921 4.55109 13 4.75 13H13.25C13.4489 13 13.6397 12.921 13.7803 12.7803C13.921 12.6397 14 12.4489 14 12.25V3H11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.25V3H0.75C0.551088 3 0.360322 3.07902 0.21967 3.21967C0.0790176 3.36032 0 3.55109 0 3.75L0 15.25C0 15.4489 0.0790176 15.6397 0.21967 15.7803C0.360322 15.921 0.551088 16 0.75 16H9.25C9.44891 16 9.63968 15.921 9.78033 15.7803C9.92098 15.6397 10 15.4489 10 15.25V14H4.75C4.28602 13.9995 3.84119 13.815 3.51311 13.4869C3.18503 13.1588 3.0005 12.714 3 12.25ZM13.7812 2.28125L11.7188 0.218752C11.6489 0.149165 11.5661 0.0940266 11.4749 0.0564914C11.3837 0.0189562 11.2861 -0.00023949 11.1875 2.25522e-06H11V3H14V2.81063C14 2.61218 13.9213 2.42182 13.7812 2.28125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_4279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyW);
export default __webpack_public_path__ + "static/media/copy-w.57f381fa91b4c9a8f5b0ae4a6ec8aa28.svg";
export { ForwardRef as ReactComponent };